import React from "react";
import {useQuery} from "@apollo/client";
import ListTable from "../../shared/ListTable";

import {getDiseasesQuery} from "../../client/diseases/DiseaseQueries";
import Loader from "../../shared/Loader";

const ClientDiseasesList = ({ client }) => {
  const { data, loading } = useQuery(getDiseasesQuery, { variables: { clientId: client.id } })

  const header = <tr>
    <th>Afectiune</th>
    <th>Cronica</th>
    <th>Detalii</th>
  </tr>

  const listItem = (item, index) => {
    return <tr key={index}>
      <td>{item.name}</td>
      <td>{item.chronic ? "Da" : "Nu"}</td>
      <td>{item.details}</td>
    </tr>
  }

  if (loading) return <Loader />;
  
  return (
    <div className="row justify-content-md-center">
      <div className=" justify-content-md-center">
        <div className="page-container col">
          <ListTable data={data && data.diseases} header={header} listItem={listItem}
                     searchFields={['name', 'details']} />
        </div>
      </div>
    </div>
  )
};

export default ClientDiseasesList;
